/**
 * EJDER SOYLU — model doğrulama örneği (Adım 1)
 *
 * Bu ırk modelin ZOR kısımlarının hepsini birden tetikler:
 *   - seviyeye bağlı özellik (3/5/7/9/13/17)
 *   - 1/N seçim (hasar türü) ve seçimin 5. seviye özelliğini ETKİLEMESİ
 *   - "en az" kuralı (Pençe: hasar zarı 1d6 olur)
 *   - uçuş hızı gibi metinsel/aktif yetenekler (metin olarak modellenir)
 */

import type { RaceEntry } from '@tttrpg/rules'

export const EJDER_SOYLU: RaceEntry = {
  id: 'ejder-soylu',
  name: 'Ejder Soylu',
  size: 'Orta',
  reach: 5,
  speed: 30,
  abilityBonuses: {},
  asiChoices: {},
  asi: 0,
  asiChoiceOptions: [],
  acBase: 10,
  darkvision: 0,
  cantrips: [],
  feat: null,
  innateSpells: [],

  // --- SEÇİM: hasar türü. Seçilmeden 3. seviye direnci hesaplanamaz. ---
  choices: [
    {
      id: 'ejder-nefesi-tur',
      label: 'Dragon Breath Damage Type',
      labelTr: 'Ejder Nefesi Hasar Türü',
      description: 'Ejder Nefesi’nin hasar türünü seç. 3. seviyede bu türe direnc kazanırsın.',
      min: 1,
      max: 1,
      options: [
        {
          id: 'acid',
          name: 'Acid',
          nameTr: 'Asit (Acid)',
          description: 'Asit 3. seviyede direnç verir.',
          effects: { damageType: 'asit' },
        },
        {
          id: 'cold',
          name: 'Cold',
          nameTr: 'Soğuk (Cold)',
          description: 'Soğuk 3. seviyede direnç verir.',
          effects: { damageType: 'soğuk' },
        },
        {
          id: 'fire',
          name: 'Fire',
          nameTr: 'Ateş (Fire)',
          description: 'Ateş 3. seviyede direnç verir.',
          effects: { damageType: 'ateş' },
        },
        {
          id: 'lightning',
          name: 'Lightning',
          nameTr: 'Yıldırım (Lightning)',
          description: 'Yıldırım 3. seviyede direnç verir.',
          effects: { damageType: 'yıldırım' },
        },
        {
          id: 'poison',
          name: 'Poison',
          nameTr: 'Zehir (Poison)',
          description: 'Zehir 3. seviyede direnç verir.',
          effects: { damageType: 'zehir' },
        },
      ],
    },
  ],

  features: [
    {
      id: 'ejder-nefesi',
      name: 'Ejder Nefesi',
      grantedAtLevel: 1,
      description:
        'Eylemle 15 ft koni veya 30 ft çizgi nefes saldırısı. Seçtiğin hasar türünde 1d10 hasar (5. sv 2d10, 11. sv 3d10, 17. sv 4d10). Çeviklik Kurtarma Atışı (DC 8 + PB + CON mod). Kullanım: PB / Uzun Dinlenme.',
    },
    {
      id: 'ejder-drakonik-direnc',
      name: 'Drakonik Direnç',
      grantedAtLevel: 3,
      // direnç, seçilen hasar türüne BAĞLI — bu yüzden burada sabit yazılmaz.
      // Uygulama aşamasında seçim çözümleyici bu özelliği dinamik doldurur.
      description: 'Ejder Nefesi için seçtiğin hasar türüne direnc kazanırsın.',
    },
    {
      id: 'ejder-pence-darbesi',
      name: 'Pençe Darbesi',
      grantedAtLevel: 5,
      description: 'Yakın dövüş çıplak vuruş hasarın 1d6 olur; Güç veya Çeviklik kullanabilirsin.',
      naturalWeapon: {
        name: 'Pençe',
        dice: '1d4',
        damageType: 'delici',
        ability: 'str',
        finesse: true,
        minimumDice: '1d6',
      },
    },
    {
      id: 'ejder-korkusu',
      name: 'Ejder Korkusu',
      grantedAtLevel: 7,
      description:
        'Bonus eylemle 10 ft içindeki seçtiğin yaratıklar Algı Kurtarma Atışı yapar. Başarısız olanlar 1 tur senden korkar.',
    },
    {
      id: 'ejder-kanat-acilimi',
      name: 'Kanat Açılımı',
      grantedAtLevel: 9,
      description:
        'Bonus eylemle 10 dakika boyunca hızına eşit uçuş hızı kazanırsın. 1 / Uzun Dinlenme.',
    },
    {
      id: 'ejder-element-tasmasi',
      name: 'Element Taşması',
      grantedAtLevel: 13,
      description:
        'Seçtiğin elementle hasar verirken hedefin o türe direnci varsa o saldırı için direnci yok sayabilirsin. Ejder Nefesi 3d10 olur. Kullanım: PB / Uzun Dinlenme.',
    },
    {
      id: 'ejder-kadim-nefes',
      name: 'Kadim Nefes',
      grantedAtLevel: 17,
      description:
        '1 / Uzun Dinlenme: 60 ft koni, 6d10 hasar, başarılı kurtarma atışında yarı hasar.',
    },
  ],
}
